import axios from "axios";
import BrowserHistory from "./BrowserHistory.js";
// import { store } from '../index';

class Service {
  constructor() {
    const service = axios.create({
      // baseURL: 'https://myteam.biznetx.org'
      baseURL: "https://eldocs.net"
      // baseURL: 'http://192.168.1.104:8000'
      // baseURL: 'http://127.0.0.1:8000'
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
    this.handleError = this.handleError.bind(this);
  }

  handleSuccess(response) {
    return response;
  }

  handleError = error => {
    // store.dispatch(finishedLoading())
    // console.log(error);
    if (error.response) {
      switch (error.response.data.error) {
        case "token_expired":
        case "auth.permission":
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          BrowserHistory.push("/login");
          return Promise.reject(error);
        // break;
        default:
          console.error("error");
          break;
      }
    } else {
      console.log(error);
    }
    return Promise.reject(error);
  };

  get(path) {
    return this.service.get(path);
  }

  post(path, payload) {
    return this.service.request({
      method: "POST",
      url: path,
      responseType: "json",
      data: payload
    });
  }

  delete(path) {
    return this.service.delete(path);
  }

  put(path, payload) {
    return this.service.request({
      method: "POST",
      url: path + "/update",
      responseType: "json",
      data: payload
    });
  }
}

export default new Service();



// WEBPACK FOOTER //
// ./src/providers/service.js